import { useEffect, useState } from 'react';

export const usePersistedState = (defaultValue, key) => {
    const keyWithStudio = key;

    const [value, setValue] = useState(() => {
        if (typeof window === 'undefined') return defaultValue;
        const value = window.localStorage.getItem(keyWithStudio);
        return value && value !== 'undefined' ? JSON.parse(value) : defaultValue;
    });

    useEffect(() => {
        window.localStorage.setItem(keyWithStudio, JSON.stringify(value));
    }, [keyWithStudio, value]);

    return [value, setValue];
};



// WEBPACK FOOTER //
// ./src/hooks/usePersistedState.js